<div ngbDropdown>
  <div class="align-center"
    [ngClass]="computedClass"
    [ngbTooltip]="tooltipText"
    placement="bottom"
    ngbDropdownToggle>
    @if (iconName) {
      <sb-icon
        name="{{iconName}}"
      [ngClass]="{'mr-1' : message}"></sb-icon>
    }
    <span [ngClass]="{'hidden-xs' : messageXs}">{{isMessageTranslated ? (message | translate: messageTranslationParameters) : message}}</span>
    @if (messageXs) {
      <span class="hidden-sm hidden-md hidden-lg">{{isMessageTranslated ? (messageXs | translate: messageTranslationParameters) : messageXs}}</span>
    }
    @if (options) {
      <sb-button
        iconStyle="solid"
        iconName="chevronDown"
        buttonClass="link"
      [isAutoSize]="true"></sb-button>
    }
  </div>
  @if (options) {
    <div
      ngbDropdownMenu>
      @for (option of visibleOptions(); track option) {
        <div
          ngbDropdownItem
          aria-labelledby="dropDown"
          class="option"
          (click)="selectOption(option.id)">
          <sb-badge [message]="option.name"
            [badgeClass]="option.class"
          [isOption]="true"></sb-badge>
        </div>
      }
    </div>
  }
</div>
